import React, { useState, Dispatch } from "react";
import { StyleSheet, View } from "react-native";
import { Button, Menu, Paragraph } from "react-native-paper";

const Select = ({
  options,
  selected,
  setSelected,
}: {
  options: Array<{ name: string; value: any }> | [];
  selected: string;
  setSelected: Dispatch<string>;
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const open = () => setShowMenu(true);
  const close = () => setShowMenu(false);

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "flex-start",
        flexWrap: "wrap",
        width: "auto",
      }}
    >
      <Menu
        visible={showMenu}
        onDismiss={close}
        anchor={
          <Button
            mode="outlined"
            onPress={open}
            style={styles.buttonText}
            contentStyle={styles.buttonText}
            labelStyle={styles.buttonText}
          >
            {options.find((v) => v.value === selected).name}
          </Button>
        }
      >
        {options.map((v) => (
          <Menu.Item
            key={v.value}
            onPress={() => {
              setSelected(v.value);
              close();
            }}
            title={v.name}
          />
        ))}
      </Menu>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonText: { padding: 0, marginVertical: 2, width: "auto" },
});
export default Select;
